module.exports = __webpack_public_path__ + "static/media/food-2.7b08ee8d.jpg";